import type { FC } from 'react'

import { CardVariant, unit } from '@hcr/ui'
import { isNotUndefined } from '@hcr/utils'

import { useEarliestAccommodation, useFirstTicketDestination, useUserDetails } from '../../contexts'
import { useHeroQuery } from '../../hooks'
import { useHomeQuery } from '../../hooks/api/optimizely/queries'
import { createHomeContent } from '../../utils/api/optimizely/views'
import { LayoutNavigationError500 } from '../common'
import { BookingOverviewHome } from '../common/booking-overview/booking-overview-home'

import { HeaderHome, LayoutHome } from './common'
import { HomeDestination } from './HomeDestination'
import { HomeEmpty } from './HomeEmpty'
import { HomeLoading } from './HomeLoading'

const homeContent = createHomeContent({ slidesMargin: unit(3), variant: CardVariant.Regular })

export const Home: FC = () => {
  const earliestAccommodation = useEarliestAccommodation()
  const firstTicketDestination = useFirstTicketDestination()
  const home = useHomeQuery({ isAuthenticated: true })
  const userDetails = useUserDetails()
  const isOwner = userDetails?.data?.has_active_contracts
  const hero = useHeroQuery({ isOwner: !!isOwner })

  const hasAccommodation = isNotUndefined(earliestAccommodation.data)
  const hasTicketDestination = isNotUndefined(firstTicketDestination.data)

  if (earliestAccommodation.isError || firstTicketDestination.isError || hero.isError || home.isError) {
    return <LayoutNavigationError500 />
  }

  if (
    earliestAccommodation.isSuccess &&
    firstTicketDestination.isSuccess &&
    hero.isSuccess &&
    !hasAccommodation &&
    !hasTicketDestination
  ) {
    return <HomeEmpty hero={hero.data} />
  }

  if (earliestAccommodation.isSuccess && hero.isSuccess && !hasAccommodation) {
    return <HomeDestination hero={hero.data} />
  }

  if (hasAccommodation && hero.isSuccess && home.isSuccess) {
    return (
      <LayoutHome
        imageUrl={hero.data.imageUrl}
        header={<HeaderHome />}
        bookingOverview={<BookingOverviewHome />}
        content={home.data.content.map(homeContent)}
      />
    )
  }

  return <HomeLoading />
}
